import { DistanceFilterId } from '@ve/components/filters/distanceLiftFilter/types';

export default (numbers: number[]): DistanceFilterId | 0 => {
    const attributeIds = new Set(numbers);

    if (attributeIds.has(215) || attributeIds.has(214) || attributeIds.has(238)) { //Автобус — от 500 м
        return 3;
    }
    if (attributeIds.has(225)) { // Ski in — прямо у входа
        return 1;
    }
    if (attributeIds.has(213)) { //Пешая доступность — до 500 м
        return 2;
    }
    return 0;
};
